<template>
    <div>
        <v-dialog v-model="OvertimeNeedApproval" max-width="700px" @click:outside="closeDetails"
            @keydown.esc="closeDetails">
            <v-card class="pa-6" v-if="!loadingDetails">
                <v-gallery v-if="overtime_image != '-'" :images="overtime_image" :index="index" @close="index = null" />
                <v-container>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item two-line>
                                <v-list-item-content>
                                    <v-list-item-title class="title">{{$t('overtime_request')}}</v-list-item-title>
                                    <v-list-item-subtitle class="subtitle-2">{{ details_overtime.id }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('requested_by')}}
                                    </v-list-item-title>
                                    <v-list-item-title class="subtitle-1">{{ overtime_name.full_name }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="caption mb-2">{{ overtime_name.job_position }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('overtime_type')}}
                                    </v-list-item-title>
                                    <v-list-item-title>
                                        <v-chip small label color="success">{{ overtimeName }}</v-chip>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('overtime_date')}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="caption">
                                        {{ milisToDate(details_overtime.overtime.date) }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md3>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('overtime')}}</v-list-item-title>
                                    <v-list-item-subtitle class="caption">
                                        {{ data_overtime.start_time }} -
                                        {{ data_overtime.end_time }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md3>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('duration')}}</v-list-item-title>
                                    <v-list-item-subtitle class="caption">{{ milisToTime(data_overtime.duration) }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('description')}}
                                    </v-list-item-title>
                                    <span class="caption">{{ data_overtime.message }}</span>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('attachments')}}
                                    </v-list-item-title>
                                    <div v-if="overtime_image == '-'">
                                        <span class="caption">{{$t('no_attachment')}}</span>
                                    </div>
                                    <div v-else>
                                        <div v-for="(item, i) in overtime_image" :key="i">
                                            <v-row>
                                                <v-col md="6">
                                                    <a :href="item" target="_blank" rel="noopener noreferrer"
                                                        style="text-decoration:none;">
                                                        <span class="caption">
                                                            <v-icon small color="primary">mdi-attachment</v-icon>
                                                            &nbsp;{{$t('attachment')}}
                                                        </span>
                                                    </a>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="6">
                            <v-list-item>
                                <v-list-item-content>
                                    <div>
                                        <v-list-item-title class="subtitle-2 mb-2 font-weight-bold">
                                            <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('status_approval')}}
                                        </v-list-item-title>
                                           <!-- <div v-if="approvalType != 1">
                                        <span class="subtitle-2">{{$t('approver')}} 1</span>
                                        <v-list-item-title class="caption mt-1">
                                            {{approverCondition(1 , details_overtime.status)}}
                                            <b>{{ overtime_approver.full_name }}</b>
                                        </v-list-item-title>
                                           </div>
                                        <div>
                                           <span class="subtitle-2">{{$t('approver')}} {{approvalType == 1 ? '' : 2}}</span>
                                            <v-list-item-title class="caption mt-1">
                                                {{approverCondition(2, details_overtime.status)}}
                                                <b>{{ overtime_approver2.full_name }}</b>
                                            </v-list-item-title>
                                        </div> -->
                                        <template v-if="allApprover.length > 0">
                                            <div v-for="(item, index) in allApprover" :key="index">
                                                <span class="subtitle-2">{{$t('approver')}} {{allApprover.length > 1 ? index + 1 : ''}}</span>
                                                <v-list-item-title class="caption mt-1">
                                                {{approverCondition(allApprover.length > 1 ? index + 1 : 1, details_overtime.status)}}
                                                <b>{{ item.full_name }}</b>
                                                </v-list-item-title>
                                            </div>
                                        </template>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col cols="6">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">
                                        <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('comments')}}
                                    </v-list-item-title>
                                    <div style="max-height: 300px; overflow:auto;">
                                        <div v-for="(item, i) in overtime_comments" :key="i">
                                            <v-list-item-title class="subtitle-2">
                                                <span class="font-weight-black caption">
                                                    {{
                                                item.user.full_name
                                            }}
                                                </span>
                                            </v-list-item-title>
                                            <v-list-item-title class="subtitle-2">
                                                <span class="caption">{{ milisToHour(item.timestamp) }}</span>
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="mb-2" style="white-space: normal;">
                                                <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Submitted'
                        " class="caption">{{$t('need_approval')}}</span>
                                                <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('need_approval')}}</span>
                                                <span v-else-if="
                          (item.status == 'l1Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                                                <span v-else-if="
                          (item.status == 'l2Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                                                <span v-else-if="
                          item.status == 'l1Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                                                <span v-else-if="
                          item.status == 'l2Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                                                <span v-else-if="
                          item.status == 'l1Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                                                <span v-else-if="
                          item.status == 'l2Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                                                <span v-if="item.comment == 'Rejected'" class="caption"
                                                    v-show="false"></span>
                                                <span v-else-if="item.comment == 'Submitted'" class="caption"
                                                    v-show="false"></span>
                                                <span v-else-if="item.comment == 'Revised'" class="caption"
                                                    v-show="false"></span>
                                                <span v-else-if="item.comment == 'Approved'" class="caption"
                                                    v-show="false"></span>
                                                <span v-else v-show="true" class="caption">{{ checkComment(item.comment) }}</span>
                                            </v-list-item-subtitle>
                                        </div>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                    <div v-if="firebaseUID == details_overtime.approverId || (firebaseUID == details_overtime.approver2Id && approvalType == 1)">
                        <v-layout row>
                            <v-flex md12>
                                <v-list-item>
                                    <v-list-item-content class="justify-center">
                                        <v-dialog v-model="commentDialog" max-width="700px">
                                            <template v-slot:activator="{ on }">
                                                <v-btn color="error" v-on="on" text>{{$t('reject')}}</v-btn>
                                            </template>
                                            <v-form v-model="valid">
                                                <v-card class="pa-6 pt-3">
                                                    <v-container>
                                                        <v-layout row>
                                                            <v-flex md12>
                                                                <v-layout justify-center>
                                                                    <v-radio-group class="justify-center" row
                                                                        v-model="status_radio" :mandatory="true">
                                                                        <v-flex md6>
                                                                            <v-card class="mb-5 mr-3"
                                                                                style="cursor:pointer">
                                                                                <v-list-item three-line>
                                                                                    <v-list-item-content>
                                                                                        <v-radio color="primary"
                                                                                            value="l1Revised" selected
                                                                                            class="justify-center">
                                                                                        </v-radio>
                                                                                        <v-list-item-title
                                                                                            class="title orange--text text-center">
                                                                                            <v-icon small
                                                                                                class="orange--text">
                                                                                                mdi-file-document-edit
                                                                                            </v-icon>
                                                                                            &nbsp;{{$t('revise')}}
                                                                                        </v-list-item-title>
                                                                                        <span
                                                                                            class="overline text-center">
                                                                                           {{$t('if_inappropriate')}}
                                                                                        </span>
                                                                                    </v-list-item-content>
                                                                                </v-list-item>
                                                                            </v-card>
                                                                        </v-flex>
                                                                        <v-flex md6>
                                                                            <v-card class="ml-3" style="cursor:pointer">
                                                                                <v-list-item three-line>
                                                                                    <v-list-item-content>
                                                                                        <v-radio color="primary"
                                                                                            value="l1Rejected"
                                                                                            class="justify-center">
                                                                                        </v-radio>
                                                                                        <v-list-item-title
                                                                                            class="title error--text text-center">
                                                                                            <v-icon small
                                                                                                class="error--text">
                                                                                                mdi-file-cancel</v-icon>
                                                                                            &nbsp;{{$t('reject')}}
                                                                                        </v-list-item-title>
                                                                                        <span
                                                                                            class="overline text-center">
                                                                                           {{$t('please_fill')}}
                                                                                        </span>
                                                                                    </v-list-item-content>
                                                                                </v-list-item>
                                                                            </v-card>
                                                                        </v-flex>
                                                                    </v-radio-group>
                                                                </v-layout>
                                                                <v-divider></v-divider>
                                                                <v-list-item>
                                                                    <v-list-item-content>
                                                                        <v-textarea color="primary"
                                                                            v-model="comment_value" :rules="rules"
                                                                            filled>
                                                                            <template v-slot:label>
                                                                                <div>{{$t('reason_rejection')}}</div>
                                                                            </template>
                                                                        </v-textarea>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                                <v-flex md-12>
                                                                    <v-list-item>
                                                                        <v-list-item-content class="justify-end">
                                                                            <v-btn color="primary" class="mr-2" text
                                                                                @click="close">{{$t('cancel')}}</v-btn>
                                                                            <v-btn color="primary"
                                                                                :disabled="!valid"
                                                                                @click="rejectItem()">{{$t('send')}}</v-btn>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </v-flex>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card>
                                            </v-form>
                                        </v-dialog>
                                        <v-btn color="primary" dark @click="approveItem()">{{$t('approve')}}</v-btn>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-flex>
                        </v-layout>
                    </div>
                    <div v-else-if="
              (firebaseUID == details_overtime.approver2Id &&
              (details_overtime.status == 'l1Approved' || details_overtime.status == 'approved')) || (firebaseUID == details_overtime.approver2Id && approvalType == 1)
            ">
                        <v-layout row>
                            <v-flex md12>
                                <v-list-item>
                                    <v-list-item-content class="justify-center">
                                        <v-dialog v-model="commentDialog" max-width="700px">
                                            <template v-slot:activator="{ on }">
                                                <v-btn color="error" v-on="on" text>{{$t('reject')}}</v-btn>
                                            </template>
                                            <v-form v-model="valid">
                                                <v-card class="pa-6 pt-3">
                                                    <v-container>
                                                        <v-layout row>
                                                            <v-flex md12>
                                                                <v-layout justify-center>
                                                                    <v-radio-group class="justify-center" row
                                                                        v-model="status_radio" :mandatory="true">
                                                                        <v-flex md6>
                                                                            <v-card class="mb-5 mr-3"
                                                                                style="cursor:pointer">
                                                                                <v-list-item three-line>
                                                                                    <v-list-item-content>
                                                                                        <v-radio color="primary"
                                                                                            value="l2Revised" selected
                                                                                            class="justify-center">
                                                                                        </v-radio>
                                                                                        <v-list-item-title
                                                                                            class="title orange--text text-center">
                                                                                            <v-icon small
                                                                                                class="orange--text">
                                                                                                mdi-file-document-edit
                                                                                            </v-icon>
                                                                                            &nbsp;{{$t('revise')}}
                                                                                        </v-list-item-title>
                                                                                        <span
                                                                                            class="overline text-center">
                                                                                           {{$t('if_inappropriate')}}
                                                                                        </span>
                                                                                    </v-list-item-content>
                                                                                </v-list-item>
                                                                            </v-card>
                                                                        </v-flex>
                                                                        <v-flex md6>
                                                                            <v-card class="ml-3" style="cursor:pointer">
                                                                                <v-list-item three-line>
                                                                                    <v-list-item-content>
                                                                                        <v-radio color="primary"
                                                                                            value="l2Rejected"
                                                                                            class="justify-center">
                                                                                        </v-radio>
                                                                                        <v-list-item-title
                                                                                            class="title error--text text-center">
                                                                                            <v-icon small
                                                                                                class="error--text">
                                                                                                mdi-file-cancel</v-icon>
                                                                                            {{$t('reject')}}
                                                                                        </v-list-item-title>
                                                                                        <span
                                                                                            class="overline text-center">
                                                                                           {{$t('please_fill')}}
                                                                                        </span>
                                                                                    </v-list-item-content>
                                                                                </v-list-item>
                                                                            </v-card>
                                                                        </v-flex>
                                                                    </v-radio-group>
                                                                </v-layout>
                                                                <v-divider></v-divider>
                                                                <v-list-item>
                                                                    <v-list-item-content>
                                                                        <v-textarea color="primary"
                                                                            v-model="comment_value" :rules="rules"
                                                                            filled>
                                                                            <template v-slot:label>
                                                                                <div>{{$t('reason_rejection')}}</div>
                                                                            </template>
                                                                        </v-textarea>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                                <v-flex md-12>
                                                                    <v-list-item>
                                                                        <v-list-item-content class="justify-end">
                                                                            <v-btn color="primary" class="mr-2" text
                                                                                @click="close">{{$t('cancel')}}</v-btn>
                                                                            <v-btn color="primary"
                                                                                :disabled="!valid"
                                                                                @click="rejectItem()">{{$t('send')}}</v-btn>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </v-flex>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card>
                                            </v-form>
                                        </v-dialog>
                                        <v-btn color="primary" dark @click="approveItem()">{{$t('approve')}}</v-btn>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-container>
            </v-card>
            <v-card class="pa-6" v-if="loadingDetails">
                <v-row>
                    <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="approveOvertime" max-width="700px" @click:outside="closeDetails" @keydown.esc="closeDetails">
            <v-card class="pa-6" v-if="!loadingDetails">
                <v-gallery v-if="overtime_image != '-'" :images="overtime_image" :index="index" @close="index = null" />
                <v-container>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item two-line>
                                <v-list-item-content>
                                    <v-list-item-title class="title">{{$t('overtime_request')}}</v-list-item-title>
                                    <v-list-item-subtitle class="subtitle-2">{{ details_overtime.id }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('requested_by')}}
                                    </v-list-item-title>
                                    <v-list-item-title class="subtitle-1">{{ overtime_name.full_name }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="caption mb-2">{{ overtime_name.job_position }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('overtime_type')}}
                                    </v-list-item-title>
                                    <v-list-item-title>
                                        <v-chip small label color="success">{{ overtimeName }}</v-chip>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('overtime_date')}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="caption">
                                        {{ milisToDate(details_overtime.overtime.date) }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md3>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('overtime')}}</v-list-item-title>
                                    <v-list-item-subtitle class="caption">
                                        {{ data_overtime.start_time }} -
                                        {{ data_overtime.end_time }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md3>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('duration')}}</v-list-item-title>
                                    <v-list-item-subtitle class="caption">{{ milisToTime(data_overtime.duration) }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('description')}}
                                    </v-list-item-title>
                                    <span class="caption">{{ data_overtime.message }}</span>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('attachments')}}
                                    </v-list-item-title>
                                    <div v-if="overtime_image == '-'">
                                        <span class="caption">{{$t('no_attachment')}}</span>
                                    </div>
                                    <div v-else>
                                        <div v-for="(item, i) in overtime_image" :key="i">
                                            <v-row>
                                                <v-col md="6">
                                                    <a :href="
                            item
                          " target="_blank" rel="noopener noreferrer" style="text-decoration:none;">
                                                        <span class="caption">
                                                            <v-icon small color="primary">mdi-attachment</v-icon>
                                                            &nbsp;{{$t('attachment')}}
                                                        </span>
                                                    </a>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="6">
                            <v-list-item>
                                <v-list-item-content>
                                    <div>
                                        <v-list-item-title class="subtitle-2 mb-2 font-weight-bold">
                                            <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('status_approval')}}
                                        </v-list-item-title>
                                           <!-- <div v-if="approvalType != 1">
                                        <span class="subtitle-2">{{$t('approver')}} 1</span>
                                        <v-list-item-title class="caption mt-1">
                                            {{approverCondition(1 , details_overtime.status)}}
                                            <b>{{ overtime_approver.full_name }}</b>
                                        </v-list-item-title>
                                           </div>
                                        <div>
                                            <span class="subtitle-2">{{$t('approver')}} {{approvalType == 1 ? '' : 2}}</span>
                                            <v-list-item-title class="caption mt-1">
                                                {{approverCondition(2, details_overtime.status)}}
                                                <b>{{ overtime_approver2.full_name }}</b>
                                            </v-list-item-title>
                                        </div> -->
                                        <template v-if="allApprover.length > 0">
                                            <div v-for="(item, index) in allApprover" :key="index">
                                                <span class="subtitle-2">{{$t('approver')}} {{allApprover.length > 1 ? index + 1 : ''}}</span>
                                                <v-list-item-title class="caption mt-1">
                                                {{approverCondition(allApprover.length > 1 ? index + 1 : 1, details_overtime.status)}}
                                                <b>{{ item.full_name }}</b>
                                                </v-list-item-title>
                                            </div>
                                        </template>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col cols="6">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">
                                        <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('comments')}}
                                    </v-list-item-title>
                                    <div style="max-height: 300px; overflow:auto;">
                                        <div v-for="(item, i) in overtime_comments" :key="i">
                                            <v-list-item-title class="subtitle-2">
                                                <span class="font-weight-black caption">
                                                    {{
                        item.user.full_name
                        }}
                                                </span>
                                            </v-list-item-title>
                                            <v-list-item-title class="subtitle-2">
                                                <span class="caption">{{ milisToHour(item.timestamp) }}</span>
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="mb-2" style="white-space: normal;">
                                                <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Submitted'
                        " class="caption">{{$t('need_approval')}}</span>
                                                <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('need_approval')}}</span>
                                                <span v-else-if="
                          (item.status == 'l1Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                                                <span v-else-if="
                          (item.status == 'l2Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                                                <span v-else-if="
                          item.status == 'l1Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                                                <span v-else-if="
                          item.status == 'l2Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                                                <span v-else-if="
                          item.status == 'l1Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                                                <span v-else-if="
                          item.status == 'l2Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                                                <span v-if="item.comment == 'Rejected'" class="caption"
                                                    v-show="false"></span>
                                                <span v-else-if="item.comment == 'Submitted'" class="caption"
                                                    v-show="false"></span>
                                                <span v-else-if="item.comment == 'Revised'" class="caption"
                                                    v-show="false"></span>
                                                <span v-else-if="item.comment == 'Approved'" class="caption"
                                                    v-show="false"></span>
                                                <span v-else v-show="true" class="caption">{{ checkComment(item.comment) }}</span>
                                            </v-list-item-subtitle>
                                        </div>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-card class="pa-6" v-if="loadingDetails">
                <v-row>
                    <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="revisedOvertime" max-width="700px" @click:outside="closeDetails" @keydown.esc="closeDetails">
            <v-card class="pa-6" v-if="!loadingDetails">
                <v-gallery v-if="overtime_image != '-'" :images="overtime_image" :index="index" @close="index = null" />
                <v-container>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item two-line>
                                <v-list-item-content>
                                    <v-list-item-title class="title">{{$t('overtime_request')}}</v-list-item-title>
                                    <v-list-item-subtitle class="subtitle-2">{{ details_overtime.id }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('requested_by')}}
                                    </v-list-item-title>
                                    <v-list-item-title class="subtitle-1">{{ overtime_name.full_name }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="caption mb-2">{{ overtime_name.job_position }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('overtime_type')}}
                                    </v-list-item-title>
                                    <v-list-item-title>
                                        <v-chip small label color="success">{{ overtimeName }}</v-chip>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('overtime_date')}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="caption">
                                        {{ milisToDate(details_overtime.overtime.date) }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md3>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('overtime')}}</v-list-item-title>
                                    <v-list-item-subtitle class="caption">
                                        {{ data_overtime.start_time }} -
                                        {{ data_overtime.end_time }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md3>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('duration')}}</v-list-item-title>
                                    <v-list-item-subtitle class="caption">{{ milisToTime(data_overtime.duration) }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('description')}}
                                    </v-list-item-title>
                                    <span class="caption">{{ data_overtime.message }}</span>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                        <v-flex md6>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">{{$t('attachments')}}
                                    </v-list-item-title>
                                    <div v-if="overtime_image == '-'">
                                        <span class="caption">{{$t('no_attachment')}}</span>
                                    </div>
                                    <div v-else>
                                        <div v-for="(item, i) in overtime_image" :key="i">
                                            <v-row>
                                                <v-col md="6">
                                                    <a :href="
                            item
                          " target="_blank" rel="noopener noreferrer" style="text-decoration:none;">
                                                        <span class="caption">
                                                            <v-icon small color="primary">mdi-attachment</v-icon>
                                                            &nbsp;{{$t('attachment')}}
                                                        </span>
                                                    </a>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="6">
                            <v-list-item>
                                <v-list-item-content>
                                    <div>
                                        <v-list-item-title class="subtitle-2 mb-2 font-weight-bold">
                                            <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('status_approval')}}
                                        </v-list-item-title>
                                           <!-- <div v-if="approvalType != 1">
                                        <span class="subtitle-2">{{$t('approver')}} 1</span>
                                        <v-list-item-title class="caption mt-1">
                                            {{approverCondition(1 , details_overtime.status)}}
                                            <b>{{ overtime_approver.full_name }}</b>
                                        </v-list-item-title>
                                           </div>
                                        <div>
                                             <span class="subtitle-2">{{$t('approver')}} {{approvalType == 1 ? '' : 2}}</span>
                                            <v-list-item-title class="caption mt-1">
                                                {{approverCondition(2, details_overtime.status)}}
                                                <b>{{ overtime_approver2.full_name }}</b>
                                            </v-list-item-title>
                                        </div> -->
                                        <template v-if="allApprover.length > 0">
                                            <div v-for="(item, index) in allApprover" :key="index">
                                                <span class="subtitle-2">{{$t('approver')}} {{allApprover.length > 1 ? index + 1 : ''}}</span>
                                                <v-list-item-title class="caption mt-1">
                                                {{approverCondition(allApprover.length > 1 ? index + 1 : 1, details_overtime.status)}}
                                                <b>{{ item.full_name }}</b>
                                                </v-list-item-title>
                                            </div>
                                        </template>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col cols="6">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="subtitle-2 font-weight-bold">
                                        <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('comments')}}
                                    </v-list-item-title>
                                    <div style="max-height: 300px; overflow:auto;">
                                        <div v-for="(item, i) in overtime_comments" :key="i">
                                            <v-list-item-title class="subtitle-2">
                                                <span class="font-weight-black caption">
                                                    {{
                        item.user.full_name
                        }}
                                                </span>
                                            </v-list-item-title>
                                            <v-list-item-title class="subtitle-2">
                                                <span class="caption">{{ milisToHour(item.timestamp) }}</span>
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="mb-2" style="white-space: normal;">
                                                <span class="caption">{{ checkComment(item.comment) }}</span>
                                            </v-list-item-subtitle>
                                        </div>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-card class="pa-6" v-if="loadingDetails">
                <v-row>
                    <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        name: "Overtime",
        props: ["OvertimeNeedApproval", 'allApprover', "approvalType", "overtime_image", "index", "loadingDetails", "details_overtime", "milisToHour",
            "commentApprover", "checkReasonColor", "checkReasonApproveColor", "approveDialog", "approveOvertime",
            "revisedOvertime",
            "checkNoteApproveColor", "firebaseUID", "overtime_name", "overtime_approver", "overtime_approver2",
            "overtime_comments", "milisToDate", "milisToTime", "overtimeName", "data_overtime", 'rules', 'close',
            'approveItem', 'checkApprover', "approverCondition"
        ],
        data() {
            return {
                commentDialog: false,
                comment_value: null,
                status_radio: 'revised',
                valid: true
            };
        },
        methods: {
            closeDetails() {
                this.$emit('closeDetails', false);
            },
            closeComments() {
                this.$emit('closeComments', false);
            },
            cancelReject() {
                this.commentDialog = false;
            },
            rejectItem() {
                this.$emit('rejectItem', this.comment_value, this.status_radio);
            },
           checkComment(comment){
                const lowComment = comment.toLowerCase()
                if(lowComment == 'approved' || lowComment == 'rejected' || lowComment == 'revised' || lowComment == 'submitted' || lowComment == "cancelled"){
                    return this.$i18n.t((comment).toLowerCase())
                }else{
                    return comment
                }
            },
        }
    };
</script>
<style scoped>
    .v-divider {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    .blueimp-gallery {
        background: rgba(0, 0, 0, 0.7) !important;
    }

    .blueimp-gallery-display {
        display: block;
        opacity: 1;
    }
</style>